<template>

    <div class="panel">
        <div class="panel-heading"><h2><img src="../../assets/img/live-qa-icon.png">Upcoming Sessions<i class="clippie fa fa-info-circle" v-tooltip="'Your next live session countdown.'"></i></h2></div>
      
        <div class="panel-body" v-if="meetings">
            <ul class="meetings list-group">
                <li v-for="meeting in meetings" class="list-group-item">
                    <h6>Group {{groupName(meeting.group)}}</h6>
                    <span class="start-time">{{meeting.startTime | longDate}}</span>
                    <div>
                        <countdown :duration="meeting.duration" :date="meeting.startTime"></countdown>
                    </div>
                  
                </li>

            </ul>
        </div>
    </div>

</template>


    <script>

    import meetings from '../../services/meetings';
    import countdown from '../reusable/countdown/CountdownTimer.vue';


    export default {
        data() {
            return {
                meetings:null,
                groups: null
            }
        },
        components:{ countdown },
        mounted() {
            this.getMeetings();
        },
        methods: {
            getMeetings() {
                var self = this;
                meetings.getSupervisorMeetings(this).then(function(response) {
                    console.log(response);
                    self.meetings = response.data.meetings;
                    self.groups = response.data.groups;
                });
            },
            groupName(id) {                
                let index = this.groups.findIndex(function(g) { return g.id == id});
                return this.groups[index].label;
            }
        }
    }

    </script>


<style lang="scss" scoped>

    .panel-heading {
        img {
            margin-right:1rem!important;
        }
    }
</style>


// WEBPACK FOOTER //
// SupervisorSessions.vue?855120ee